module.exports = __webpack_public_path__ + "static/media/thumb-jocelyn.ea6bf17a.png";